import { observer } from 'mobx-react';
import React from 'react';
import { Button } from 'reactstrap';
import { Action } from '~/lib/ApiModel';
import { requiresUserAttention } from '~/lib/helper/ActionHelper';
import { handleButtonKeyDown } from '~/lib/helper/AccessibilityHelper';
import LabelledProgress from '~/components/LabelledProgress';

import './ActionProgressMini.scss';

type ActionProgressSectionProps = {
    action: Action;
    onClick?: (action: Action) => void;
    /** Ref to the banner's clickable control, whichever branch is rendered. */
    controlRef?: React.Ref<HTMLDivElement>;
};

@observer
export default class ActionProgressSection extends React.Component<ActionProgressSectionProps> {
    render() {
        const actionInProgress = this.props.action;
        return (
            <div className="mini-banner-dock actionProgressMini">
                {requiresUserAttention(actionInProgress) ? (
                    // The whole wrap is the interactive control. The inner
                    // "Show..." is rendered as a styled span (tag="span") so
                    // we keep the visual button affordance without nesting two
                    // interactive elements.
                    <div
                        ref={this.props.controlRef}
                        role="button"
                        tabIndex={0}
                        className="mini-banner-card actionProgressWrap"
                        onClick={() => this.props.onClick?.(actionInProgress)}
                        onKeyDown={(e) => handleButtonKeyDown(e, () => this.props.onClick?.(actionInProgress))}
                    >
                        <div className="d-flex flex-row align-items-center mb-0 p-1">
                            <div className="flex-grow-1">
                                <i className="icon ion-md-alert me-2 text-warning interactionAlertIcon"></i>{' '}
                                {actionInProgress.title} - User interaction required
                            </div>
                            <Button tag="span" size="sm">
                                Show...
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div className="mini-banner-card actionProgressWrap">
                        <div
                            ref={this.props.controlRef}
                            className="actionProgressText"
                            role="button"
                            tabIndex={0}
                            onClick={() => this.props.onClick?.(actionInProgress)}
                            onKeyDown={(e) => handleButtonKeyDown(e, () => this.props.onClick?.(actionInProgress))}
                        >
                            {`${actionInProgress.title} - ${actionInProgress.progress.current_step ?? 'Pending'}`}
                            {actionInProgress.progress.current_step_detail &&
                                ` - ${actionInProgress.progress.current_step_detail}`}
                        </div>
                        <LabelledProgress
                            value={actionInProgress.progress.percent_complete}
                            className="actionProgress"
                            label={`${actionInProgress.title} progress`}
                        />
                    </div>
                )}
            </div>
        );
    }
}
